import { Component, OnInit,HostListener  } from '@angular/core';
import * as pdfjsLib from 'pdfjs-dist';
import { HttpClient } from '@angular/common/http';
import { PdfWatermarkService } from 'src/app/pdf-watermark.service';
import { ActivatedRoute } from '@angular/router'; // Importa ActivatedRoute

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.css']
})
export class PdfViewerComponent implements OnInit {
  constructor(
    private watermarkService: PdfWatermarkService,
    private http: HttpClient,
    private route: ActivatedRoute
  ) {}
  //pdfSrc: string | Uint8Array = '';

  @HostListener('contextmenu', ['$event'])
  onContextMenu(event: MouseEvent): void {
    // Evitar que se muestre el menú contextual
    event.preventDefault();
  }
  
  pdfSrc = '../assets/pdfs/sample.pdf'; // Ruta al archivo PDF

  ngOnInit(): void {
    // Captura el valor de la URL
    this.route.queryParams.subscribe(params => {
      const pdfPathFromUrl = params['url']; // Reemplaza 'pdfPath' con el nombre real del parámetro


      if (pdfPathFromUrl) {
        // Carga el PDF desde la URL y conviértelo en Uint8Array
        this.http.get(pdfPathFromUrl, { responseType: 'arraybuffer' }).subscribe(
          (data: ArrayBuffer) => {
            const pdfData = new Uint8Array(data);
            const watermarkText = 'Copia no controlada';

            // Llama al servicio para agregar la marca de agua al PDF
            this.watermarkService.addWatermarkToPdf(pdfData, watermarkText).then((pdfWithWatermark) => {
              // Renderiza el PDF con marca de agua
              this.renderPdf(pdfWithWatermark);
            });
          },
          (error) => {
            console.error('Error al cargar el PDF:', error);
          }
        );
      }
    });
  }

  renderPdf(pdfData: Uint8Array): void {
    pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";

    pdfjsLib.getDocument(pdfData).promise.then(pdf => {
      // Obtén la primera página del PDF
      pdf.getPage(1).then(page => {
        const canvas = document.getElementById('pdfCanvas') as HTMLCanvasElement;
        const context = canvas.getContext('2d') as CanvasRenderingContext2D;
        const viewport = page.getViewport({ scale: 1 });

        // Establece el tamaño del lienzo según la página
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        // Renderiza la página en el lienzo
        page.render({ canvasContext: context, viewport: viewport });
      });
    });
  }

  loadPDF(): void {

    pdfjsLib.GlobalWorkerOptions.workerSrc =
    "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";

    pdfjsLib.getDocument(this.pdfSrc).promise.then(pdf => {
      // Obtén la primera página del PDF
      pdf.getPage(1).then(page => {
        const canvas = document.getElementById('pdfCanvas') as HTMLCanvasElement;
        const context = canvas.getContext('2d') as CanvasRenderingContext2D;
        const viewport = page.getViewport({ scale: 1 });

        // Establece el tamaño del lienzo según la página
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        // Renderiza la página en el lienzo
        page.render({ canvasContext: context, viewport: viewport });
      });
    });
  }
}